import React from 'react';
import { Box } from '@mui/material';
import Banner from './Banner';
import Text from './Text';
import Signup from './Signup';

const Homepage: React.FC = () => {
    return (
        <>
            <Box mt={6}>
                <Banner />
            </Box>
            <Box mt={6}>
                <Text />
            </Box>
            <Box mt={6}>
                <Signup />
            </Box>
        </>
    );
};

export default Homepage;
